import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SuperAdminService from '../services/SuperAdminService';
import './SuperAdminLogin.css';

function SuperAdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await SuperAdminService.login(username, password);
      if (response && response.success) {
        localStorage.setItem('superAdminToken', response.token);
        localStorage.setItem('superAdminUser', JSON.stringify({
          username: response.username,
          email: response.email,
          role: response.role
        }));
        onLogin(response.token);
        navigate('/superadmin');
      } else {
        setError(response?.error || 'Login failed. Please try again.');
      }
    } catch (err) {
      setError(err.message || 'Server connection error.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="superadmin-login-body">
      <div className="superadmin-login-box">
        <div className="superadmin-login-header">
          <div className="superadmin-logo-circle">S²G</div>
          <h2>Super Admin Portal</h2>
          <p>Platform Management &amp; Institution Administration</p>
        </div>
        
        {error && <div className="superadmin-error-bubble">{error}</div>}

        <form onSubmit={handleSubmit} className="superadmin-login-form">
          <div className="superadmin-input-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter super admin username"
              required
              disabled={loading}
            />
          </div>

          <div className="superadmin-input-group">
            <label htmlFor="password">Password</label>
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter secure password"
                required
                disabled={loading}
                style={{ paddingRight: '44px', width: '100%' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(prev => !prev)}
                title={showPassword ? "Hide password" : "Show password"}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '6px 8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#94a3b8'
                }}
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <button 
            type="submit" 
            className={`superadmin-btn-submit ${loading ? 'btn-loading' : ''}`}
            disabled={loading}
          >
            {loading ? 'Authenticating Security Gateway...' : 'Secure Authorization Login'}
          </button>
        </form>

        <div className="superadmin-login-footer">
          <p>🛡️ End-to-End Encrypted Session Gateway</p>
          <span className="gateway-version">v2.4.0-SECURE</span>
        </div>
      </div>
    </div>
  );
}

export default SuperAdminLogin;
